<template>
  <div>
    <HeadBar />
    <HeadNav />
    <div class="main">
      <div class="main-inner">
        <div class="main-inner-left">
          <div class="main-inner-head">
            <div>{{ info.standardFileTitle }}</div>
            <!-- <el-button
            class="main-inner-head-btn"
            plain
            type="primary"
            @click="collectClick"
          >
            {{ info.isCollect === 1 ? "已托管" : "托管" }}
          </el-button> -->
          </div>
          <div class="main-inner-content">
            <iframe
              :src="src"
              frameborder="0"
              style="height: 100%; width: 100%"
            >
            </iframe>
          </div>
        </div>

        <RankLists />
      </div>
    </div>
    <FootBar />
  </div>
</template>

<script>
// import { collectPlateformData } from "@/api/common";
import { standardFileDetail } from "@/api/standardFile";
import { mapGetters } from "vuex";
import RankLists from "./components/rankLists";
export default {
  components: {
    RankLists,
  },
  data() {
    return {
      src: "",
      info: {},
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  created() {
    if (this.token) {
      this.getDetail();
    }
  },
  methods: {
    async getDetail() {
      const res = await this.$axios.get(standardFileDetail, {
        standardFileId: this.$route.query.id,
      });
      this.info = res;
      this.src = this.$oss(
        `static/pdf/web/viewer.html?file=${res.standardFilePath}`
      );
    },

    // 托管
    // async collectClick() {
    //   if (!this.token) {
    //     this.$store.dispatch("login");
    //     return;
    //   }
    //   const { standardFileId, isCollect } = this.info;
    //   await this.$axios.post(
    //     isCollect === 1 ? deleteCollect : collectPlateformData,
    //     {
    //       resourceId: standardFileId,
    //       collectType: "6", // 标准
    //     }
    //   );
    //   this.$message.success(isCollect === 1 ? "取消托管成功" : "托管成功");
    //   this.getDetail();
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/variable";
.main {
  background: #f5f5f5;
  padding-top: 20px;
  padding-bottom: 30px;
  &-inner {
    width: $max-width;
    margin: 0 auto;
    display: grid;
    grid-template-columns: calc(70% - 20px) 30%;
    gap: 20px;
    &-left {
      background: #ffffff;
      padding: 15px;
    }
    &-head {
      text-align: center;
      font-size: 20px;
      line-height: 1.8;
      font-weight: 500;
      border-bottom: 1px solid $border-color;
      position: relative;
      min-height: 50px;
      &-time {
        font-size: 14px;
        color: #999;
        font-weight: 400;
      }
      &-btn {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    &-content {
      padding-top: 16px;
      height: 930px;
    }
  }
}
</style>
